/**
 * Formats a street address with unit type and number if available.
 * @param street - The street address
 * @param unitType - Optional unit type (e.g., "Apt", "Unit", "Suite")
 * @param unitNumber - Optional unit number
 * @returns Formatted street address with unit information, or null if street is not provided
 */
export function formatStreetAddress(
  street?: string | null,
  unitType?: string | null,
  unitNumber?: string | null,
): string | null {
  if (!street) {
    return null;
  }
  if (unitType && unitNumber) {
    return `${street} ${unitType} ${unitNumber}`;
  }
  if (unitNumber) {
    return `${street} #${unitNumber}`;
  }
  return street;
}
